import verification from "./verification"
import cache from "../config/cache"

export default (error) => {
    try {
        let body = error.response && error.response.data ? error.response.data : '';
        switch(error.response && error.response.status) {
            case 591: 
                cache.set('dealerList', body.data);
                cache.router.push('dealerselect');
                break;
            case 405:
            case 401:
                cache.router.push('nopermissins');
                break;
            case 511:
                location.href = body.redirectTo;
                sessionStorage.setItem("redirecTo_url", body.redirectTo);
                break;
            case 582:
                verification.show(body);
                break;
            default:
                return Promise.reject(error);
        }
	} catch (error) {
        return Promise.reject(error);
	}
}